import { useEffect } from 'react';

import { redirectToLogin } from '@/shared/api/redirect-to-sign-in';
import { listenForSession } from '@/shared/utils/session-channel';
import { writeSignedOut } from '@/shared/utils/signed-out-flag';

/** Follows what another tab of this app did to the shared session. */
export const useSessionSync = (): void => {
  useEffect(
    () =>
      listenForSession((message) => {
        if (message === 'role-switched') {
          window.location.reload();
          return;
        }

        // Session storage is per tab, so this tab has to note the sign-out itself.
        writeSignedOut(true);
        redirectToLogin('signed out in another tab');
      }),
    [],
  );
};
